// extracted by mini-css-extract-plugin
export default {"DailyCard":"dailyInfoCard_DailyCard__K7yvX"};